import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsHeroNavVisible(entry.isIntersecting);
        const navbar = document.querySelector(".navbar.alt");
        if (navbar) {
          if (!entry.isIntersecting) {
            navbar.style.marginTop = "0px";
          } else {
            navbar.style.marginTop = "-100px";
          }
        }
      },
      { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (

    <div className="App">
      <ResponsiveAppBarAlt />

      <main>

        <Box className="heroWrapper subpage" id="start">

          <img src="News.webp" className='herobackimg' />
          <Box className='heroWrapperLayer'></Box>
          <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

          </Container>

          <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
            <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
            <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
            <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
            <HashLink className='navItemHero' smooth to="/Blog">Blog</HashLink>
            <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
            <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
          </Box>

          {/* <div className="heroCTAWrapper">
      <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
    </div> */}
        </Box>


        <Box className="mainWrapper">

          <Container maxWidth="lg" className="subPageContainerThin">

            <Typography variant='h1' className='subTitle'>Blog</Typography><br /><br />  


            <Box className="blogList">

              <Box className="blogItemWrapper">
                <Box className="blogItemTextWrapper">
                  <Typography variant='h2' className='blogItemTitle'>Ich will eine Immobilie kaufen oder verkaufen: Worauf muss ich rechtlich achten?</Typography>
                  <Typography variant='body' className='blogItemText'>Der Kauf oder Verkauf einer Immobilie bringt zahlreiche rechtliche Fragen mit sich. Von Grundbuchrechten über Altlasten bis hin zu Mietverhältnissen und Energiepflichten – Käufer und Verkäufer sollten mögliche Risiken frühzeitig prüfen, um kostspielige Überraschungen und rechtliche Streitigkeiten zu vermeiden.</Typography>
                  <Button className='btnSecondarySmall' href="/immobilien-kaufen-verkaufen">Jetzt lesen</Button>
                </Box>
              </Box>

              <Box className="blogItemWrapper">
                <Box className="blogItemTextWrapper">
                  <Typography variant='h2' className='blogItemTitle'>In der GmbH ist ein Gesellschafter verstorben – Wie gehen wir damit um?</Typography>
                  <Typography variant='body' className='blogItemText'>Der Tod eines GmbH-Gesellschafters wirft zahlreiche rechtliche und organisatorische Fragen auf. Von der Aktualisierung der Gesellschafterliste über die Rechte der Erben bis hin zur Handlungsfähigkeit der Gesellschaft – schnelles und rechtssicheres Vorgehen ist entscheidend, um Konflikte und Risiken für die GmbH zu vermeiden.</Typography>
                  <Button className='btnSecondarySmall' href="/verstorbener-gesellschafter">Jetzt lesen</Button>
                </Box>
              </Box>

              <Box className="blogItemWrapper">
                <Box className="blogItemTextWrapper">
                  <Typography variant='h2' className='blogItemTitle'>Lebensgefährten erwerben eine Immobilie zusammen: Was müssen wir beachten?</Typography>
                  <Typography variant='body' className='blogItemText'>Unverheiratete Paare, die gemeinsam eine Immobilie erwerben, riskieren ungewollte Schenkungsteuer, hohe Kosten bei Trennung und Erbschaftskonflikte. Eine Gesellschaft bürgerlichen Rechts (GbR) bietet flexible Lösungen: keine Schenkung bei ungleicher Tilgung, geringere Kosten und Schutz vor Teilungsversteigerung. Frühzeitige Beratung durch Notar empfohlen.</Typography>
                  <Button className='btnSecondarySmall' href="/immobilie-erwerben">Jetzt lesen</Button>
                </Box>
              </Box>

              <Box className="blogItemWrapper">
                <Box className="blogItemTextWrapper">
                  <Typography variant='h2' className='blogItemTitle'>Wie man ein Berliner Testament repariert</Typography>
                  <Typography variant='body' className='blogItemText'>Ein Berliner Testament kann Steuernachteile und starre Bindungen verursachen. Nach dem Tod des ersten Ehepartners gibt es zwei Wege zur Reparatur: Kinder können den Pflichtteil fordern oder der überlebende Ehegatte schlägt das Erbe gegen Abfindung aus. So lassen sich Freibeträge nutzen und Flexibilität zurückgewinnen.</Typography>
                  <Button className='btnSecondarySmall' href="/berlin-testament">Jetzt lesen</Button>
                </Box>
              </Box>

            </Box>

          </Container>



          <Box className="map" id="map">
            <Box className="contactMap">

              {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}

              <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                <img src="Karte-HT.webp" className="contactMapImg" />
                <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
              </a>
              <Container maxWidth="lg" className="container">
                <Typography variant='body1' paragraph className="contactMapAddress">
                  Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                </Typography>
              </Container>

            </Box>
            {/* <Container maxWidth="lg" id="routelink">
                                                        <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                                    </Container> */}

          </Box>


          <Box className="section bannergrey" id="kontakt">
            <Container maxWidth="lg" className="container" id="kontakt">
              <Box className="kontaktGrid">
                <Box className="kontaktLeftSide smaller">
                  <Typography variant='h2' className='sectionTitle white small'>
                    Sie haben Fragen?  <br />
                    Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                  </Typography>
                  <Typography variant='body1' paragraph className='whiteText smaller'>
                    <b>Öffnungszeiten</b><br />
                    Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                    Mittwoch ab 13:00 Uhr geschlossen<br />
                    Spätere Termine sind nach Vereinbarung möglich<br />
                  </Typography>
                  <Typography variant='body1' paragraph className='whiteText smaller'>
                    <b>Telefon</b><br />
                    Sie erreichen uns unter: 02241 66444<br />
                    Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                    Mittwoch nur bis 13:00 Uhr. <br />
                  </Typography>
                  <Typography variant='body1' paragraph className='whiteText smaller'>
                    <b>E-mail: info@ht-notare.de</b><br />
                  </Typography>
                  <Typography variant='body1' paragraph className='whiteText smaller'>
                    <b>Fax: 02241 55161</b><br />
                  </Typography>
                  <Typography variant='body1' paragraph className='whiteText smaller'>
                    <b>Anfahrt und Parkmöglichkeiten</b><br />
                    Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. In der Tiefgarage Holzgasse können Sie die markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Garage rechts abbiegen und dann bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                  </Typography>
                </Box>
                <Contactform />
              </Box>
            </Container>
          </Box>



        </Box>

      </main >
      <Footer />
    </div >
  );
};

export default ScrollAnimation;